import { createRoot } from "react-dom/client";
import { App } from "./components/app";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

function start() {
  const queryClient = new QueryClient();
  const root = createRoot(document.getElementById("root")!);
  root.render(
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>,
  );
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", start);
} else {
  start();
}
